<template>
  <div class="customer-page">
    <title-menu
        :icon="'fad fa-users'"
        :id="'candidates'"
        :title="customer.name"
    >
      <template slot="menu">
        <customer-menu
            :activePage="customerPage"
            :customer="customer"
            @setCustomerPage="setCustomerPage"
        />
      </template>
    </title-menu>
    <div class="row m-reverse-xl">
      <div class="col mw-250">
        <div class="edit-nav-block m-hide-xl">
          <customer-menu
              :activePage="customerPage"
              :customer="customer"
              @setCustomerPage="setCustomerPage"
          />

        </div>

        <edit-information
            v-if="customer"
            :customer="true"
            :value="customer"
            :customerContactMoments="customerContactMoments"
            @saveContactMoment="saveContactMoment"
        />

      </div>

      <div class="col">
        <component
            :is="customerPage"
            :customer="customer"
            v-if="customerLoaded"
            :id="id"
            @unsavedChanges="hasUnsavedChanges($event)"
            @update:customer="updateCustomer"
            @setCustomerPage="setCustomerPage"
        ></component>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import titleMenu from "../../components/titleMenu"
import customerMenu from "../../components/customer/customerMenu"
import editInformation from "./../../components/editInformation";
import customerInfo from "../../components/customer/customerInfo";
import customerCandidatePlacing from "../../components/customer/customerCandidatePlacing";
import customerPlacingHistory from "../../components/customer/customerPlacingHistory";
import customerDocuments from "../../components/customer/customerDocuments";
import {swalModals} from "../../components/mixins/swalModals.js";
import customerPoolOverview from "../../components/customer/customerPoolOverview";
import customerStatistics from "../../components/customer/customerStatistics";
import customerAppointments from "../../views/appointments/appointments";
import customerOvertimeSettings from "../../components/customer/customerOvertimeSettings";
import customerVisits from "../../components/customer/customerVisits";
import customerAppOnboarding from "../../components/customer/customerAppOnboarding";
import { mayViewAppOnboarding } from "@/utils/appOnboardingAccess";

const CUSTOMER_PAGES = {
  customerInfo: null,
  customerCandidatePlacing: null,
  customerPlacingHistory: null,
  customerDocuments: null,
  customerPoolOverview: null,
  customerAppointments: null,
  customerStatistics: null,
  customerOvertimeSettings: null,
  customerVisits: null,
  customerAppOnboarding: mayViewAppOnboarding,
};

const DEFAULT_CUSTOMER_PAGE = 'customerInfo';

export default {
  mixins: [swalModals],
  props: ["id"],
  components: {
    titleMenu,
    customerMenu,
    editInformation,
    customerInfo,
    customerCandidatePlacing,
    customerPlacingHistory,
    customerDocuments,
    customerPoolOverview,
    customerStatistics,
    customerAppointments,
    customerOvertimeSettings,
    customerVisits,
    customerAppOnboarding
  },
  data() {
    return {
      disableNavigation: false,
      customerPage: DEFAULT_CUSTOMER_PAGE,
      renderedComponent: true,
      customerLoaded: false,
      customerCopy: null,
      customer: {}
    };
  },
  methods: {
    resolveCustomerPage(page) {
      if (!Object.prototype.hasOwnProperty.call(CUSTOMER_PAGES, page)) {
        return DEFAULT_CUSTOMER_PAGE;
      }

      const mayOpen = CUSTOMER_PAGES[page];

      return mayOpen === null || mayOpen() ? page : DEFAULT_CUSTOMER_PAGE;
    },
    hasUnsavedChanges(event) {
      this.disableNavigation = event;
    },
    setCustomerPage(page) {
      const resolvedPage = this.resolveCustomerPage(page);

      if (this.disableNavigation) {
        this.swalUnsavedChanges().then(result => {
          if (result.value) {
            this.customer = this.customerCopy;
            this.customerPage = resolvedPage;
            this.disableNavigation = false
          }
        });
      } else {
        this.customerPage = resolvedPage;
      }
    },
    saveContactMoment(contactMoment) {
      this.$store.dispatch('customerContactMoments/insert', { ...contactMoment, customerId: this.id })
        .then(() => {
          this.$toasted.global.successRequest({ message: 'Contactmoment succesvol opgeslagen' });
        })
        .catch(() => {
          this.$toasted.global.failedRequest();
        });
    },
    updateCustomer(customer) {
      const nextCustomer = customer || {};

      this.customer = Object.assign({}, nextCustomer);
      this.customerCopy = Object.assign({}, nextCustomer);
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.disableNavigation) {
      this.swalUnsavedChanges().then(result => {
        if (result.value) {
          next();
          this.customer = this.customerCopy;
        }
      });
    } else {
      next();
    }
  },
  computed: {
    ...mapGetters("vacancies", [
      "getVacancies",
      "getVacanciesFromCustomer"
    ]),
    ...mapGetters("candidates", ["getCandidates"]),
    ...mapGetters("placementsHistory", ["getPlacementsHistoryArray"]),
    ...mapGetters("customerContactMoments", ["getCustomerContactMoments"]),
    customerContactMoments() {
      return this.getCustomerContactMoments.filter(contactMoment => contactMoment.customerId === this.id);
    }
  },

  created() {
    this.customerPage = this.resolveCustomerPage(this.$route.query.tab);

    let id = this.id;
    this.$store.dispatch("customers/fetchById", id).then(res => {
      this.customer = Object.assign({}, res);
      this.customerLoaded = true;
      this.customerCopy = Object.assign({}, res);
    });
    this.$store.dispatch('customerContactMoments/openDBChannel', { where: [['customerId', '==', this.id]] });
  }
};
</script>
